import React from 'react'
import { TranslationProvider as TranslationProviderBase, useTranslation } from '@repo/translation'

const loadJson = () => {
  return new Promise((res) => {
    import('../intl/lang.json').then((data) => {
      res(data?.default)
    })
  })
}

export const TranslationProvider = ({ children }) => {
  return <TranslationProviderBase loadJson={loadJson}>{children}</TranslationProviderBase>
}

export { useTranslation }
